var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalogSensor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64,17c25.57,0,46.3,21.042,46.3,47c0,25.957-20.729,47-46.3,47S17.7,89.957,17.7,64 C17.7,38.042,38.429,17,64,17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#baa0b5",
    d: "M96.8,30.8L88.6,39l0.101,0.2c6.2,6.4,10.1,15.1,10.1,24.8H110.4C110.3,51,105.2,39.3,96.8,30.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#bdc5cc",
    d: "M64,17v11.8c9.5,0,18.2,3.9,24.5,10.2h0.1l8.137-8.236c-5.099-5.175-11.382-9.15-18.401-11.467 c-4.509-1.485-9.321-2.294-14.315-2.296C64.013,17,64.008,17,64,17"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7dce0",
    d: "M64,17c-0.008,0-0.013,0-0.021,0c-9.664,0.004-18.642,3.029-26.075,8.171 c-2.383,1.653-4.606,3.528-6.641,5.592L39.2,38.8l-0.031,0.069L39.2,38.9l0.8-0.3c6.2-6,14.7-9.7,24-9.7v-0.1l0,0V17L64,17"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebeef0",
    d: "M31.214,30.814C22.862,39.315,17.7,51.045,17.7,64h11.5l0,0c0-9.4,3.7-18,9.6-24.3l0.37-0.831 L31.214,30.814"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f37778",
    d: "M110.3,64H98.8c0,9.7-3.899,18.5-10.2,24.9l8.2,8.3C105.2,88.7,110.3,77,110.3,64z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.2,64L29.2,64H17.7l0,0c0,12.955,5.162,24.684,13.514,33.186L39.4,88.9 C33.1,82.5,29.2,73.7,29.2,64"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#454b54",
    d: "M64,114c-27.2,0-49.4-22.4-49.4-50S36.8,14,64,14s49.4,22.4,49.4,50S91.2,114,64,114z M64,20 c-23.9,0-43.4,19.7-43.4,44S40,108,64,108s43.4-19.7,43.4-44S87.9,20,64,20z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#7c8b99",
    d: "M64,56.3c4.197,0,7.6,3.448,7.6,7.7c0,4.253-3.402,7.7-7.6,7.7s-7.6-3.447-7.6-7.7 C56.4,59.748,59.803,56.3,64,56.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#454b54",
    d: "M64,74.7c-5.9,0-10.6-4.8-10.6-10.7S58.1,53.3,64,53.3S74.6,58.1,74.6,64S69.9,74.7,64,74.7z M64,59.3c-2.6,0-4.6,2.1-4.6,4.7c0,2.6,2.1,4.7,4.6,4.7s4.6-2.101,4.6-4.7C68.6,61.4,66.6,59.3,64,59.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#454b54",
    d: "M96.8,100.2c-0.8,0-1.6-0.3-2.1-0.9L86.4,91c-1.2-1.2-1.2-3,0-4.2c6-6.1,9.3-14.2,9.3-22.8 c0-17.8-14.2-32.2-31.8-32.2S32.2,46.2,32.2,64c0,8.6,3.3,16.7,9.3,22.8c1.2,1.2,1.2,3,0,4.2l-8.2,8.3c-1.1,1.101-3.1,1.101-4.3,0 c-9.3-9.4-14.4-22-14.4-35.3c0-27.6,22.1-50,49.4-50s49.4,22.4,49.4,50c0,13.3-5.101,25.9-14.4,35.3 C98.3,99.9,97.6,100.2,96.8,100.2z M92.7,88.8l4,4c6.899-8,10.6-18.2,10.6-28.9c0-24.3-19.399-44-43.4-44c-24,0-43.3,19.8-43.3,44.1 c0,10.7,3.8,20.9,10.6,28.9l4-4c-5.9-6.9-9-15.601-9-24.801C26.2,43,43.1,25.9,64,25.9s37.8,17.2,37.8,38.2 C101.8,73.2,98.6,81.9,92.7,88.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#454b54",
    d: "M69.5 61.5c-.8 0-1.5-.3-2.1-.9-1.2-1.2-1.2-3.1 0-4.2l13.3-13.5c1.2-1.2 3.1-1.2 4.2 0 1.199 1.2 1.199 3.1 0 4.2L71.6 60.6C71 61.2 70.2 61.5 69.5 61.5zM73.1 99.8H54.9c-1.7 0-3-1.3-3-3s1.3-3 3-3h18.3c1.7 0 3 1.3 3 3S74.8 99.8 73.1 99.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalogSensor);
export default __webpack_public_path__ + "static/media/analogSensor.ed7f825c3e845129b4ce65a7eb4554a5.svg";
export { ForwardRef as ReactComponent };